import React, { useState, useEffect } from 'react';
import { getAhlinCMSbyId } from '../../../reduxStore/HeadlessCMS/headlessCmsActions';
import { useDispatch, useSelector } from 'react-redux';


const NyheterCMS = (props) => {
    const [content, setContent] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);


    const localeMessages = props.localeMessages
    const articleId = props.articleId
    const showToasts = true;

    const dispatch = useDispatch()

    const cmsArticlesState = useSelector(state => state.headlessCMS)
    const existing = cmsArticlesState.data[articleId];

    useEffect(() => {
        let isMounted = true;
        // Ikke hent om allerede hentet
        if (existing) {
            setContent(Array.isArray(existing) ? existing : []);
            setLoading(false);
            return;
        }

        setLoading(true);
        const fetchData = async () => {
            try {
                const data = await dispatch(getAhlinCMSbyId(articleId, showToasts, localeMessages));
                if (isMounted) {
                    setContent(Array.isArray(data) ? data : []);
                }
            } catch (err) {
                if (isMounted) {
                    setError(err.message);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchData();

        return () => {
            isMounted = false;
        };
        }, [ articleId, existing, dispatch, showToasts ] 
    );

    if (error) return <p>Noe gikk galt ved henting av artikkel</p>;

    return (
        <div>
            {content && content.length > 0 ? (
                content.map((item) => (
                    <div key={item.id}>
                        <h1 dangerouslySetInnerHTML={{ __html: item.title.rendered }}></h1>
                        <div dangerouslySetInnerHTML={{ __html: item.content.rendered }}></div>
                    </div>
                ))
            ) : loading ? (
                <div style={{ color: '#666', fontFamily: "Fellix, sans-serif", fontSize: '16px', padding: '20px' }}>
                    Laster info...
                </div>
            ) : (
                <div style={{ color: 'red', textAlign: 'center', fontWeight: '600', fontFamily: "Fellix, sans-serif", fontSize: '20px' }}>
                    Noe gikk galt ved henting av nyheter, du kan fortsatt bruke Kunderportalen som vanlig.
                </div>
            )}
        </div>
    );
};

export default NyheterCMS;
